import { FC, useEffect, useState } from "react";
import { Loader } from "taltech-styleguide";
import { OverrideValueTable } from "./OverrideValueTable";
import { application } from "../../../_runtime/bootstrap";
import { useLoading } from "../../../components-common/_shared/loading/use-loading.hook";

type Props = {
  tableItems: any[];
  title: string;
};


/**
 * Functional Component: TypeCreationParametersTable
 * 
 * This component renders a table of type creation parameters. It displays a title and uses the `OverrideValueTable` component 
 * to render the items in the table.
 * 
 * Props:
 * @param {Props} props - The properties passed to the component.
 * @param {any[]} props.tableItems - An array of items to be displayed in the table.
 * @param {string} props.title - The title to be displayed above the table.
 * 
 * Returns:
 * @returns {JSX.Element} A JSX element containing the title and the table of type creation parameters.
 */
export const TypeCreationParametersTable: FC<Props> = ({ tableItems, title }) => {
  return (
    <div className="mt-3">
      <h1>{title}</h1>
      <OverrideValueTable tableItems={tableItems} />
    </div>
  );
};
